// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SidePanel_overlay__G-2ly","overlayOpened":"SidePanel_overlayOpened__3jDnf","content":"SidePanel_content__23JAY"};